/* MI CASA — la página. Cuadros Splash (24 sep 2026).

   Pinta las paredes guardadas (assets/cs-mi-casa-datos.js) por habitación,
   con el precio y la disponibilidad DE HOY: lo guardado puede tener
   semanas, así que cada obra se vuelve a leer de la tienda
   (/products/<handle>?view=salon, la misma ficha JSON que usa el probador).

   Si una talla ya no está disponible, la pared se enseña igual pero no
   entra en "Añadir toda mi casa a la cesta": una línea agotada haría fallar
   la petición entera de /cart/add.js, y el cliente se quedaría sin nada.
*/
(function () {
  'use strict';

  var raiz = document.querySelector('[data-cs-casa]');
  if (!raiz) return;
  function $(s) { return raiz.querySelector(s); }

  var el = {
    resumen: $('[data-cs-casa-resumen]'),
    n: $('[data-cs-casa-n]'),
    total: $('[data-cs-casa-total]'),
    nota: $('[data-cs-casa-nota]'),
    todo: $('[data-cs-casa-todo]'),
    todoT: $('[data-cs-casa-todo-t]'),
    filtros: $('[data-cs-casa-filtros]'),
    lista: $('[data-cs-casa-lista]'),
    vacio: $('[data-cs-casa-vacio]'),
    sinAlmacen: $('[data-cs-casa-sin-almacen]'),
    plantilla: $('[data-cs-casa-tarjeta]'),
  };

  var casa = window.csMiCasa;
  var probador = raiz.dataset.probador || '/pages/cuelgalo-en-tu-casa';
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var formato;
  try { formato = new Intl.NumberFormat('es-ES', { style: 'currency', currency: raiz.dataset.moneda || 'EUR' }); } catch (e) { formato = null; }
  function euros(cent) {
    var v = cent / 100;
    return formato ? formato.format(v).replace(/,00\s/, ' ') : v.toFixed(0) + ' €';
  }

  var paredes = [];
  var fichas = {};   /* handle -> ficha de hoy (o null si ya no existe) */
  var filtro = 'todas';
  var urls = [];

  if (!casa || !casa.disponible) {
    el.sinAlmacen.hidden = false;
    return;
  }

  function ficha(handle) {
    if (fichas[handle] !== undefined) return Promise.resolve(fichas[handle]);
    /* Sin cabecera accept JSON: con ella Shopify se salta ?view=salon. */
    return fetch('/products/' + encodeURIComponent(handle) + '?view=salon')
      .then(function (r) { if (!r.ok) throw new Error('ficha'); return r.text(); })
      .then(function (t) { return JSON.parse(t); })
      .catch(function () { return null; })
      .then(function (f) { fichas[handle] = f; return f; });
  }

  /* La talla guardada, con su precio y disponibilidad de hoy. */
  function tallaHoy(p) {
    var f = fichas[p.obra.handle];
    if (!f) return { disponible: false, precio: p.talla.precio, motivo: 'Esta obra ya no está en la tienda.' };
    var v = (f.variantes || []).filter(function (x) { return x.id === p.talla.id; })[0];
    if (!v) return { disponible: false, precio: p.talla.precio, motivo: 'Esa talla ya no existe: ábrela y elige otra.' };
    return { disponible: !!v.disponible, precio: v.precio, motivo: v.disponible ? '' : 'Agotada en esta talla: ábrela y elige otra.' };
  }

  function cargar() {
    return casa.todas().then(function (l) {
      paredes = l;
      var handles = {};
      l.forEach(function (p) { handles[p.obra.handle] = true; });
      return Promise.all(Object.keys(handles).map(ficha));
    }).then(pintar).catch(function () {
      el.sinAlmacen.hidden = false;
    });
  }

  function pintar() {
    urls.forEach(function (u) { URL.revokeObjectURL(u); });
    urls = [];
    el.lista.innerHTML = '';

    var hay = paredes.length > 0;
    el.vacio.hidden = hay;
    el.resumen.hidden = !hay;
    el.filtros.hidden = !hay;
    if (!hay) return;

    /* Resumen: lo que entra en la cesta es lo disponible. */
    var disp = paredes.filter(function (p) { return tallaHoy(p).disponible; });
    var total = disp.reduce(function (s, p) { return s + tallaHoy(p).precio; }, 0);
    el.n.textContent = paredes.length === 1 ? '1 pared' : paredes.length + ' paredes';
    el.total.textContent = euros(total);
    var fuera = paredes.length - disp.length;
    el.nota.hidden = !fuera;
    el.nota.textContent = fuera === 1 ? '1 no disponible, no se añadirá' : fuera + ' no disponibles, no se añadirán';
    el.todo.disabled = !disp.length;

    /* Filtros por habitación, solo las que tienen algo. */
    var cuenta = {};
    paredes.forEach(function (p) { cuenta[p.estancia] = (cuenta[p.estancia] || 0) + 1; });
    if (filtro !== 'todas' && !cuenta[filtro]) filtro = 'todas';
    el.filtros.innerHTML = '';
    [['todas', 'Toda la casa', paredes.length]].concat(
      casa.ESTANCIAS.filter(function (e) { return cuenta[e[0]]; }).map(function (e) { return [e[0], e[1], cuenta[e[0]]]; })
    ).forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs-casa__filtro';
      b.setAttribute('aria-pressed', f[0] === filtro ? 'true' : 'false');
      b.innerHTML = '<span></span> <small></small>';
      b.firstChild.textContent = f[1];
      b.lastChild.textContent = f[2];
      b.addEventListener('click', function () { filtro = f[0]; pintar(); });
      el.filtros.appendChild(b);
    });

    /* Una sección por habitación, en el orden de la casa. */
    casa.ESTANCIAS.forEach(function (e) {
      if (!cuenta[e[0]] || (filtro !== 'todas' && filtro !== e[0])) return;
      var sec = document.createElement('section');
      sec.className = 'cs-casa__habitacion';
      var h = document.createElement('h2');
      h.className = 'cs-casa__h2';
      h.textContent = e[1];
      var c = document.createElement('span');
      c.className = 'cs-casa__h2-n';
      c.textContent = cuenta[e[0]] === 1 ? '1 pared' : cuenta[e[0]] + ' paredes';
      h.appendChild(c);
      var grid = document.createElement('div');
      grid.className = 'cs-casa__rejilla';
      paredes.filter(function (p) { return p.estancia === e[0]; }).forEach(function (p) { grid.appendChild(tarjeta(p)); });
      sec.appendChild(h);
      sec.appendChild(grid);
      el.lista.appendChild(sec);
    });

    if (!reducir && window.csLib) {
      window.csLib.pide('gsap').then(function () {
        if (window.gsap) window.gsap.from(el.lista.querySelectorAll('.cs-casa__pared'), { y: 18, opacity: 0, duration: 0.6, stagger: 0.06, ease: 'power3.out', clearProps: 'all' });
      }).catch(function () {});
    }
  }

  function tarjeta(p) {
    var n = el.plantilla.content.firstElementChild.cloneNode(true);
    var hoy = tallaHoy(p);
    var ir = probador + (probador.indexOf('?') >= 0 ? '&' : '?') + 'pared=' + encodeURIComponent(p.id);

    var u = URL.createObjectURL(p.imagen);
    urls.push(u);
    var img = n.querySelector('img');
    img.src = u;
    img.alt = p.obra.titulo + ' en tu ' + casa.nombre(p.estancia).toLowerCase();
    n.querySelectorAll('[data-ir]').forEach(function (a) { a.href = ir; });

    var f = n.querySelector('[data-ficha]');
    f.textContent = p.obra.titulo;
    f.href = p.obra.url + '?variant=' + p.talla.id;
    n.querySelector('[data-talla]').textContent = p.talla.nombre.replace(/\s*cm$/i, ' cm') + ' · ' + euros(hoy.precio);
    if (hoy.motivo) {
      var est = n.querySelector('[data-estado]');
      est.hidden = false;
      est.textContent = hoy.motivo;
    }

    var cesta = n.querySelector('[data-cesta]');
    cesta.disabled = !hoy.disponible;
    cesta.addEventListener('click', function () {
      anadir([p], cesta, 'Añadir a la cesta');
    });

    var sel = n.querySelector('[data-mover]');
    casa.ESTANCIAS.forEach(function (e) {
      var o = document.createElement('option');
      o.value = e[0];
      o.textContent = e[0] === p.estancia ? e[1] : 'Mover a ' + e[1];
      if (e[0] === p.estancia) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () {
      casa.mover(p.id, sel.value).then(cargar);
    });

    n.querySelector('[data-bajar]').addEventListener('click', function () {
      var a = document.createElement('a');
      a.href = u;
      a.download = 'mi-pared-' + p.obra.handle + '.jpg';
      document.body.appendChild(a);
      a.click();
      a.remove();
    });

    /* Quitar pide confirmación con un segundo toque: nada de ventanas. */
    var quitar = n.querySelector('[data-quitar]');
    var armado = null;
    quitar.addEventListener('click', function () {
      if (!armado) {
        quitar.classList.add('es-armado');
        quitar.setAttribute('aria-label', 'Toca otra vez para quitarla');
        quitar.title = 'Toca otra vez para quitarla';
        armado = setTimeout(function () {
          armado = null;
          quitar.classList.remove('es-armado');
          quitar.title = 'Quitar de Mi casa';
        }, 2500);
        return;
      }
      clearTimeout(armado);
      n.classList.add('es-saliendo');
      setTimeout(function () { casa.borrar(p.id).then(cargar); }, reducir ? 0 : 280);
    });
    return n;
  }

  /* ---------- La cesta ---------- */

  function anadir(lista, boton, texto) {
    /* Ya añadido: el mismo botón pasa a llevar a la cesta. */
    if (boton.dataset.irCesta) { window.location.href = '/cart'; return; }
    var items = lista.filter(function (p) { return tallaHoy(p).disponible; })
      .map(function (p) { return { id: Number(p.talla.id), quantity: 1 }; });
    if (!items.length) return;
    var t = boton.querySelector('span') || boton;
    boton.disabled = true;
    t.textContent = 'Añadiendo…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { if (!r.ok) throw new Error('cesta'); return r.json(); })
      .then(function () {
        t.textContent = items.length === 1 ? 'En la cesta ✓' : items.length + ' cuadros en la cesta ✓';
        contadorCesta();
        if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cs-mi-casa' }); } catch (e) { /* nada */ }
        }
        setTimeout(function () {
          boton.disabled = false;
          t.textContent = 'Ver la cesta';
          boton.dataset.irCesta = '1';
        }, 1300);
      })
      .catch(function () {
        boton.disabled = false;
        t.textContent = 'No se ha podido añadir. Prueba otra vez';
        setTimeout(function () { t.textContent = texto; }, 2500);
      });
  }

  el.todo.addEventListener('click', function () {
    anadir(paredes, el.todo, el.todoT.textContent);
  });

  /* Igual que asesor.js y el probador: se vuelve a pedir la burbuja entera. */
  function contadorCesta() {
    fetch('/?sections=cart-icon-bubble', { headers: { accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) {
        if (!s || !s['cart-icon-bubble']) return;
        var destino = document.getElementById('cart-icon-bubble');
        if (!destino) return;
        var doc = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html');
        var origen = doc.querySelector('.shopify-section');
        if (origen) destino.innerHTML = origen.innerHTML;
      })
      .catch(function () {});
  }

  cargar();
})();
